module.exports = __webpack_public_path__ + "media/images/sp/brands/aqua/store_fuji-0d43ebd27ebfc4490e29ccbe2e0b1494.jpg";